// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunks/" + chunkId + ".chunk.js?id=" + "c674476419d59b5b" + "";
};